var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSale = function SvgIconSale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 3.5A5.256 5.256 0 0 0 3.5 8.75 5.256 5.256 0 0 0 8.75 14 5.256 5.256 0 0 0 14 8.75 5.256 5.256 0 0 0 8.75 3.5Zm0 7.5A2.247 2.247 0 0 1 6.5 8.75 2.247 2.247 0 0 1 8.75 6.5 2.247 2.247 0 0 1 11 8.75 2.247 2.247 0 0 1 8.75 11Zm13.5 6A5.256 5.256 0 0 0 17 22.25a5.256 5.256 0 0 0 5.25 5.25 5.256 5.256 0 0 0 5.25-5.25A5.256 5.256 0 0 0 22.25 17Zm0 7.5A2.247 2.247 0 0 1 20 22.25 2.247 2.247 0 0 1 22.25 20a2.247 2.247 0 0 1 2.25 2.25 2.247 2.247 0 0 1-2.25 2.25Zm-16.635 3L3.5 25.385 25.385 3.5 27.5 5.615 5.615 27.5Z",
    fill: "#fff"
  })));
};
export default SvgIconSale;